import { render, staticRenderFns } from "./SignAbyServizi.vue?vue&type=template&id=cf46b1b0&scoped=true&"
import script from "./SignAbyServizi.vue?vue&type=script&lang=js&"
export * from "./SignAbyServizi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf46b1b0",
  null
  
)

export default component.exports